import { useState } from 'react';

type ShowFilterOrSearch = [boolean, boolean, () => void, () => void];

export const useShowFilterOrSearch = (): ShowFilterOrSearch => {
  const [showFilters, setShowFilters] = useState<boolean>(false);
  const [showSearch, setShowSearch] = useState<boolean>(false);

  const onFilterClick = () => {
    if (showSearch) {
      setShowSearch(false);
    }
    setShowFilters((prevState) => !prevState);
  };

  const onSearchClick = (): void => {
    if (showFilters) {
      setShowFilters(false);
    }
    setShowSearch((prevState) => !prevState);
  };

  return [showFilters, showSearch, onFilterClick, onSearchClick];
};
